import { Box, Typography, Skeleton } from '@mui/material';
import React from 'react';

const AnalyticsCard = ({
    title,
    value,
    icon,
    loading = false,
    iconAlt = 'icon',
    changeValue,
    changeText = 'vs last month',
    changeColor = '#008C23',
    backgroundColor = '#FFFFFF',
    borderColor = '#ccc',
    textColor = '#111214',
    valueColor = '#111214'
}) => {
    return (
        <Box
            sx={{
                p: 2,
                border: `1px solid ${borderColor}`,
                borderRadius: 2,
                backgroundColor,
                flex: '1 1 0',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                boxShadow: '-1px 2px 4px 0px #00000033',
            }}
        >
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {loading ? (
                    <Skeleton variant="circular" width={24} height={24} />
                ) : (
                    icon && (
                        <Box
                            component="img"
                            src={icon}
                            alt={iconAlt}
                            sx={{ width: 24, height: 24 }}
                        />
                    )
                )}
                {loading ? (
                    <Skeleton variant="text" width="60%" height={24} />
                ) : (
                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: 500,
                            color: textColor,
                        }}
                    >
                        {title}
                    </Typography>
                )}
            </Box>

            {/* Main Value */}
            {loading ? (
                <Skeleton variant="text" width="80%" height={42} />
            ) : (
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 600,
                        fontSize: '28px',
                        color: valueColor,
                    }}
                >
                    {value}
                </Typography>
            )}

            {/* Change Indicator */}
            {loading ? (
                <Skeleton variant="text" width="50%" height={20} />
            ) : (
                changeValue && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 400,
                                color: changeColor,
                            }}
                        >
                            {changeValue}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 400,
                                color: '#414958',
                            }}
                        >
                            {changeText}
                        </Typography>
                    </Box>
                )
            )}
        </Box>
    );
};

export default AnalyticsCard;